// extracted by mini-css-extract-plugin
export var uploadFileBlockAside = "upload-file-block__aside_mfVYVI3hX1uNY0mfL50O";
export var uploadFileBlockContent = "upload-file-block__content_JeQL6VcwqWNp3UWBiIab";
export var uploadFileBlockDropzone = "upload-file-block__dropzone_cBS1DNZNEKneH_cUc_D7";
export var uploadFileBlockDropzoneNonActive = "upload-file-block__dropzone_non-active_cBZRiGX4iyoJLj8w3aIs";
export var uploadFileBlockHeader = "upload-file-block__header_QZ5mxw4mS08idnhLWSKa";
export var uploadFileBlockList = "upload-file-block__list_Dl8oMqXdI1FmI3KDnIo2";
export var uploadFileBlockReviewPartition = "upload-file-block__review-partition_wDhr1pFKAKUYTMqzjxaZ";
export var uploadFileBlockUploadPartition = "upload-file-block__upload-partition_Npw7K723ULkpPROBKfz9";